<template>
  <div class="container">
    <p class="item" v-for="item in sell" :key="item.title">
      <span class="title">{{item.title}}</span>
      <span class="price"  :class="{'fall-color': item.price !== '--'}">{{item.price}}</span>
      <span class="vol">{{item.vol}}</span>
    </p>
    <div class="gap" v-show="buy.length"></div>
    <p class="item" v-for="item in buy" :key="item.title"> 
      <span class="title">{{item.title}}</span>
      <span class="price" :class="{'rise-color': item.price !== '--'}">{{item.price}}</span>
      <span class="vol">{{item.vol}}</span>
    </p>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import {formatUnit} from '@/utils'
import config from '@/utils/chart/config'

export default {
  data() {
    return {
      buy: [],
      sell: []
    }
  },
  computed: {
    ...mapState(['dyna', 'region'])
  },
  watch: {
    dyna(val) {
      this.init()
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      let {BuyPrice = [], BuyVolume = [], SellPrice = [], SellVolume = []} = this.dyna
      let {precision, singleHand} = config.region[this.region]
      this.sell = Array.apply(null, {length: 5}).map((item, index) => {
        return {
          title: `卖${5 - index}`,
          price: SellPrice[4 - index] ? (SellPrice[4 - index]).toFixed(precision) : '--',
          vol:  formatUnit(SellVolume[4 - index] / singleHand, false, true, 0) || '--'
        }
      })
      this.buy = Array.apply(null, {length: 5}).map((item, index) => {
        return {
          title: `买${index + 1}`,
          price: BuyPrice[index] ? (BuyPrice[index]).toFixed(precision) : '--',
          vol: formatUnit(BuyVolume[index] / singleHand, false, true, 0) || '--'
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .container
    padding 0 .03rem
    color #0A1428
    font-weight 500

  .item
    height .29rem
    line-height .29rem
    span
      display inline-block

  .title
    width .2rem

  .price
    width .35rem
    text-align right
    font-size .11rem
  .vol
    width .4rem
    text-align right
    font-size .11rem
  
  .gap
    height 1px 
    width 100%
    background-color #EDEFF3
</style>